const types = {
	manual: 'manual',
	triggered: 'triggered'
};

const locale = {
	ru: types,
	en: types,
	uk: types,
	de: types,
	vi: types,
	th: types
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/mailing-types.js